import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { installApiAuthFetch } from './lib/installApiAuthFetch';
import { getAccessToken } from './lib/supabaseAuth';

installApiAuthFetch(getAccessToken);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

